import React, { useState } from "react";
import { totalBlog } from "../fakedata/fakedata";
import Blog from "./Blog";
import "./Blogs.css";

const Blogs = () => {
  const [blogs, setBlogs] = useState(totalBlog);
  return (
    <div id='blogs-id' className='project-container pt-5'>
      <div className='container mt-3'>
        <h1 className='mb-2 text-center'>Blogs Post</h1>
        <div className='row'>
          {blogs.map((blog, index) => (
            <Blog key={index} blog={blog} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
